import { InjectionToken } from "@angular/core";
import { INotificationAction } from "../interfaces/notification-action.interface";

export const NotificationAction = new InjectionToken<INotificationAction>('NOTIFICATION_TOKEN');